module.exports = __webpack_public_path__ + "static/media/bg-desk.d58a03d2.jpg";